import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_3 = { class: "max-w-[1040px]" }
const _hoisted_4 = {
  key: 0,
  class: "mb-4 text-sm text-red-600"
}
const _hoisted_5 = { class: "flex items-center justify-between gap-4 flex-wrap" }
const _hoisted_6 = { class: "grid gap-5 sm:grid-cols-2" }

import { computed, onMounted, reactive, ref } from 'vue'
import { onBeforeRouteLeave, useRouter } from 'vue-router'

import ExplanationBox from '@/components/ExplanationBox.vue'
import api from '@/store/api'


export default {
  __name: 'LoyaltyProgramSettings',
  setup(__props) {

const router = useRouter()

const loading = ref(true)
const loadFailed = ref(false)
const program = ref(null)
const messageTemplateId = ref(null)
const turnOffModal = ref(false)
const leaveModal = ref(false)
const saveError = ref('')
let pendingRoute = null

const isLive = computed(() => program.value?.attributes?.is_active === true)
const isTurnedOff = computed(() => program.value?.attributes?.is_active === false)

const local = reactive({
  dirty: false,
  type: 'number-orders',
  orderInterval: 10,
  intervalAmount: '100.00',
  reward: '10.00',
  message: ''
})

const centsToDollars = cents => ((cents || 0) / 100).toFixed(2)
const dollarsToCents = dollars => Math.round(parseFloat(dollars || 0) * 100)

const applyProgram = response => {
  program.value = response.data.data
  const included = response.data.included || []
  messageTemplateId.value = included.find(item => item.type === 'message_template')?.id || null
}

const fetchProgram = async () => {
  loading.value = true
  try {
    applyProgram(await api.call('GET', 'loyalty/program'))
  } catch (error) {
    if (error.response?.status === 404) {
      program.value = null
      messageTemplateId.value = null
    } else {
      loadFailed.value = true
      // eslint-disable-next-line no-console
      console.error('Error fetching loyalty program:', error)
    }
  } finally {
    loading.value = false
    resetLocal()
  }
}

const resetLocal = () => {
  const attrs = program.value?.attributes
  local.type = attrs?.loyalty_program_type || 'number-orders'
  local.orderInterval = attrs?.order_interval || 10
  local.intervalAmount = attrs ? centsToDollars(attrs.interval_amount.cents) : '100.00'
  local.reward = attrs ? centsToDollars(attrs.reward.cents) : '10.00'
  local.message = attrs?.message_text || ''
  local.dirty = false
  saveError.value = ''
}

const save = async () => {
  saveError.value = ''
  const payload = {
    loyalty_program: {
      loyalty_program_type: local.type,
      order_interval: local.type === 'number-orders' ? parseInt(local.orderInterval, 10) || 0 : 0,
      interval_amount_cents: local.type === 'amount' ? dollarsToCents(local.intervalAmount) : 0,
      reward_cents: dollarsToCents(local.reward),
      message_text: local.message,
      message_template_attributes: { id: messageTemplateId.value, body: local.message }
    }
  }
  try {
    applyProgram(await api.call('PUT', 'loyalty/program', payload))
    resetLocal()
    return true
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error saving loyalty program:', error)
    saveError.value =
      (error.response?.data?.errors || []).join(', ') || 'We could not save your loyalty program. Please try again.'
    return false
  }
}

const turnOn = async () => {
  if (await save()) router.push('/store/loyalty-program')
}

const turnOff = async () => {
  turnOffModal.value = false
  try {
    await api.call('DELETE', 'loyalty/program')
    local.dirty = false
    router.push('/store/loyalty-program')
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error turning off loyalty program:', error)
  }
}

const confirmLeave = () => {
  local.dirty = false
  leaveModal.value = false
  if (pendingRoute) router.push(pendingRoute)
}

onBeforeRouteLeave(to => {
  if (!local.dirty) return true
  pendingRoute = to.fullPath
  leaveModal.value = true
  return false
})

onMounted(fetchProgram)

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_InputField = _resolveComponent("InputField")
  const _component_SettingsSection = _resolveComponent("SettingsSection")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: "Loyalty program",
        "save-status": true,
        sections: [
          {
            id: 'overview',
            name: 'Overview',
            action: () => _unref(router).push('/store/loyalty-program')
          },
          {
            id: 'settings',
            name: 'Settings',
            active: true
          }
        ]
      }, null, 8, ["sections"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (loadFailed.value)
            ? (_openBlock(), _createBlock(ExplanationBox, {
                key: 0,
                "explanation-text": "We could not load your loyalty program. Refresh the page to try again."
              }))
            : _createCommentVNode("", true),
          (!loadFailed.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_SaveBar, {
                  "has-unsaved-changes": local.dirty,
                  onOnDiscard: resetLocal,
                  onOnSave: save
                }, null, 8, ["has-unsaved-changes"]),
                _createElementVNode("div", _hoisted_3, [
                  (saveError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(saveError.value), 1))
                    : _createCommentVNode("", true),
                  (isTurnedOff.value)
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _cache[16] || (_cache[16] = _createElementVNode("div", null, [
                              _createElementVNode("p", { class: "text-sm font-medium text-gray-900" }, "Your loyalty program is turned off"),
                              _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " No new rewards are being issued. Turn it on to resume rewards with the settings below. Saving changes also turns it on. ")
                            ], -1)),
                            _createVNode(_component_NeueButton, {
                              type: "primary",
                              onClick: turnOn
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("Turn on loyalty program", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_NeueLoading, { loading: loading.value }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SettingsSection, {
                        title: "How customers earn",
                        description: "Reward repeat customers with account credit, earned every set number of orders or every set amount spent."
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_SelectInput, {
                              modelValue: local.type,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((local.type) = $event)),
                              name: "Reward customers based on",
                              options: [
                        { name: 'Number of orders', value: 'number-orders' },
                        { name: 'Amount spent', value: 'amount' }
                      ],
                              onInput: _cache[1] || (_cache[1] = $event => (local.dirty = true))
                            }, null, 8, ["modelValue"]),
                            (local.type === 'number-orders')
                              ? (_openBlock(), _createBlock(_component_InputField, {
                                  key: 0,
                                  modelValue: local.orderInterval,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((local.orderInterval) = $event)),
                                  name: "Order interval",
                                  description: "Reward the customer every time they reach this many paid orders.",
                                  type: "number",
                                  restrict: "integer",
                                  onInput: _cache[3] || (_cache[3] = $event => (local.dirty = true))
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true),
                            (local.type === 'amount')
                              ? (_openBlock(), _createBlock(_component_InputField, {
                                  key: 1,
                                  modelValue: local.intervalAmount,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((local.intervalAmount) = $event)),
                                  name: "Spend interval",
                                  description: "Reward the customer every time their paid spend reaches this amount.",
                                  prefix: "$",
                                  restrict: "monetary",
                                  onInput: _cache[5] || (_cache[5] = $event => (local.dirty = true))
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SettingsSection, {
                        title: "Reward",
                        description: "The account credit issued each time a customer reaches the interval, and the message they get."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputField, {
                            modelValue: local.reward,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((local.reward) = $event)),
                            name: "Reward",
                            prefix: "$",
                            restrict: "monetary",
                            class: "sm:max-w-xs",
                            onInput: _cache[7] || (_cache[7] = $event => (local.dirty = true))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_InputArea, {
                            modelValue: local.message,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((local.message) = $event)),
                            name: "Message to the customer",
                            description: "Sent to the customer when they earn a reward. Leave blank to send nothing.",
                            rows: 6,
                            onInput: _cache[9] || (_cache[9] = $event => (local.dirty = true))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (isLive.value)
                        ? (_openBlock(), _createBlock(_component_SettingsSection, {
                            key: 0,
                            title: "Turn off",
                            description: "Customers keep the credit they have already earned, but no new rewards are issued.",
                            flush: ""
                          }, {
                            default: _withCtx(() => [
                              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "min-w-0" }, [
                                _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Turn off loyalty program"),
                                _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "You can set up a new program at any time.")
                              ], -1)),
                              _createElementVNode("button", {
                                class: "btn-alert shrink-0",
                                type: "button",
                                onClick: _cache[10] || (_cache[10] = $event => (turnOffModal.value = true))
                              }, "Turn off")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createVNode(_component_TheModal, {
          "is-open": turnOffModal.value,
          "modal-title": "Turn off loyalty program",
          "modal-description": "Customers keep the credit they have already earned, but no new rewards will be issued. You can set up a new program at any time.",
          onCloseModal: _cache[12] || (_cache[12] = $event => (turnOffModal.value = false))
        }, {
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn-alert justify-center mr-3",
              onClick: turnOff
            }, "Turn off"),
            _createElementVNode("button", {
              class: "btn-ghost justify-center",
              type: "button",
              onClick: _cache[11] || (_cache[11] = $event => (turnOffModal.value = false))
            }, "Keep it on")
          ]),
          _: 1
        }, 8, ["is-open"]), [
          [_vShow, turnOffModal.value]
        ]),
        _withDirectives(_createVNode(_component_TheModal, {
          "is-open": leaveModal.value,
          "modal-title": "Abandon changes",
          "modal-description": "Are you sure you'd like to leave without saving your changes?",
          onCloseModal: _cache[14] || (_cache[14] = $event => (leaveModal.value = false))
        }, {
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn-alert justify-center mr-3",
              onClick: confirmLeave
            }, "Leave"),
            _createElementVNode("button", {
              class: "btn-ghost justify-center",
              type: "button",
              onClick: _cache[13] || (_cache[13] = $event => (leaveModal.value = false))
            }, "Stay")
          ]),
          _: 1
        }, 8, ["is-open"]), [
          [_vShow, leaveModal.value]
        ])
      ])
    ]),
    _: 1
  }))
}
}

}